import { render, staticRenderFns } from "./areaCourseShowList.vue?vue&type=template&id=5c84ba54&"
import script from "./areaCourseShowList.vue?vue&type=script&lang=js&"
export * from "./areaCourseShowList.vue?vue&type=script&lang=js&"
import style0 from "./areaCourseShowList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports